import { Link } from 'react-router-dom';
import MangaCard from '@/components/feature/MangaCard';
import { mangaList } from '@/mocks/mangaData';

export default function FeaturedManga() {
  const featured = mangaList.filter((m) => m.rating >= 4.7).slice(0, 6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500">编辑精选，高分韩漫不容错过</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featured.map((manga) => (
            <MangaCard key={manga.id} {...manga} />
          ))}
        </div>

        <div className="text-center sm:hidden mt-8">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 whitespace-nowrap cursor-pointer"
          >
            查看全部漫画
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}